import { JsonConvert, JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from "json2typescript";
import { BaseResponse } from "./base-response";
import { Location } from "./location";
import { DeviceStatus, DeviceStatusConverter } from "./device-status";

@JsonConverter
export class MonitoringDeviceConverter implements JsonCustomConvert<MonitoringDevice>{
	serialize() { }
	deserialize(data: any): MonitoringDevice {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeObject(data, MonitoringDevice);
	}
}

@JsonConverter
export class MonitoringDeviceArrayConverter implements JsonCustomConvert<Array<MonitoringDevice>>{
	serialize() { }
	deserialize(data: any): Array<MonitoringDevice> {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeArray(data, MonitoringDevice);
	}
}

@JsonConverter
export class MonitoringDeviceListConverter implements JsonCustomConvert<MonitoringDeviceList>{
	serialize() { }
	deserialize(data: any): MonitoringDeviceList {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeObject(data, MonitoringDeviceList);
	}
}

@JsonObject("MonitoringDevice")
export class MonitoringDevice {
	@JsonProperty("uuid", String, true)
	uuid: string = "";
	@JsonProperty("mac", String, true)
	mac: string = "";
	@JsonProperty("name", String, true)
	name: string = "";
	@JsonProperty("ip", String, true)
	ip: string = "";
	@JsonProperty("last_seen", Number, true)
	last_seen: number = 0;
	@JsonProperty("last_seen_nasid", String, true)
	last_seen_nasid: string = "";
	@JsonProperty("monitoring", Boolean, true)
	monitoring: boolean = true;
	@JsonProperty("status", DeviceStatusConverter, true)
	status: DeviceStatus = DeviceStatus.OFFLINE;

	_location:string | undefined = "";

	setLocation(locations:Array<Location>){
		this._location = locations.find(b => b.nasid === this.last_seen_nasid) ? locations.find(b => b.nasid === this.last_seen_nasid)?.name : "" ;
	}
}

@JsonObject("MonitoringDeviceList")
export class MonitoringDeviceList {
	@JsonProperty("count", Number, true)
	count: number = 0;
	@JsonProperty("data", MonitoringDeviceArrayConverter, true)
	data: Array<MonitoringDevice> = new Array<MonitoringDevice>();

	setLocations(locations: Array<Location>) {
		this.data.forEach(d => {
			d.setLocation(locations);
		});
	}
}

@JsonObject("MonitoringDeviceData")
export class MonitoringDeviceData extends BaseResponse {
	@JsonProperty("data", MonitoringDeviceConverter, true)
	data: MonitoringDevice = new MonitoringDevice();
}

@JsonObject("MonitoringDeviceListData")
export class MonitoringDeviceListData extends BaseResponse {
	@JsonProperty("data", MonitoringDeviceListConverter, true)
	data: MonitoringDeviceList = new MonitoringDeviceList();
}